<script setup>

import { useArchive } from '@/composables/archive'

const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: false,
  },
  archived: {
    type: Boolean,
    required: false,
    default: false,
  },
  iconDisabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  hideBack: {
    type: Boolean,
    default: false,
  },
  textIcon: {
    type: String,
    required: false,
  },
  caption: {
    type: String,
    required: false,
  },
})

const { archivedChip } = useArchive()

const emit = defineEmits(['click', 'cancel'])

</script>
<template>
  <q-item class="q-pa-none custom-fixed-top" style="width: 100%;">
    <q-item-section
      v-if="!props.hideBack"
      avatar
      class="align-middle align-center q-pa-none"
      @click="emit('cancel')"
    >
      <q-icon
        name="mdi-arrow-left"
        class="cursor-pointer"
        @click="emit('cancel')"
      />
    </q-item-section>
    <q-item-section v-if="$slots['default']">
      <slot />
    </q-item-section>

    <q-item-section
      v-if="!$slots['default']"
      class="text"
      :style="`margin-right: ${props.icon || $slots['right'] ? '0' : '2rem'}`"
    >
      <div v-if="props.textIcon || props.caption" class="navigate-back__title row no-wrap items-center">
        <q-icon
          v-if="props.textIcon"
          :name="props.textIcon"
          size="sm"
          class="q-mr-sm"
        />
        <div class="column">
          <q-item-label class="text-left text-h6">{{ props.text }}</q-item-label>
          <q-item-label v-if="props.caption" caption>{{ props.caption }}</q-item-label>
        </div>
      </div>
      <q-item-label v-else class="text-left text-h6">
        {{ props.text }}
      </q-item-label>
      <q-chip v-if="props.archived" v-bind="archivedChip" />
    </q-item-section>
    <q-item-section
      v-if="!$slots['default'] && (props.icon || $slots['right'])"
      avatar
      class="align-middle align-center q-pa-none"
    >
      <slot name="right" />
      <q-btn
        v-if="!$slots['right']"
        flat
        round
        :icon="props.icon"
        :disable="props.iconDisabled"
        :color="props.iconDisabled ? 'grey' : null"
        @click="emit('click')"
      />
    </q-item-section>
  </q-item>
</template>
<style scoped lang="scss">
  .text {
    display: flex;
    align-items: center;
  }
  .custom-fixed-top {
    border-bottom: 1px solid #ccc;
    background-color: white;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15) !important;
    margin: 0;
    padding: .5rem 1rem;
    position: sticky;
    top: 0;
    z-index: 1000;
    min-height: 4rem;
  }
</style>
